import { useCallback, useEffect, useState } from 'react';
import { Toast } from 'antd-mobile';
import { CSSTransition } from 'react-transition-group';
import { useMounted, useUnmount } from '@/utils/hooks';
import { fixedBody, looseBody } from '@/utils/fn';
import { jsHandleShare, openPageNative } from '@/utils/bridge';
import { BOX_INDEX_TAG, MENU_COMMUNITY, RECRUIT_MENU_OPTIONS } from '../config/recruit.config';
import styles from '../styles/common.less';
import model from 'echarts/src/model/Model';

const CommunityModal = ({ handleClose, fromIndex }) => {
  const [modelTitle, setModelTitle] = useState('');

  const [modelQrcode, setModelQrcode] = useState('');

  const [qrcodeUrl, setQrcodeUrl] = useState('');

  const [inProp, setInProp] = useState(false);

  const saveQRCodeCallback = useCallback(
    res => {
      if (res.code === 0) {
        Toast.info('保存成功');
      } else {
        const joinCommunityMenuItem = RECRUIT_MENU_OPTIONS.find(
          item => item.type === MENU_COMMUNITY
        );
        openPageNative({
          url: joinCommunityMenuItem.url,
        });
      }
      handleClose();
    },
    [handleClose]
  );

  const handleSaveQRCode = useCallback(() => {
    jsHandleShare(
      {
        share_item: {
          platform: 6,
          share_image: modelQrcode,
        },
      },
      saveQRCodeCallback
    );
  }, [modelQrcode, saveQRCodeCallback]);

  useEffect(() => {
    switch (fromIndex) {
      case BOX_INDEX_TAG:
        console.log('in');
        setModelTitle('- 小盒子定向业务交流群 -');
        setModelQrcode(`${window.location.origin}/qrcode_smallbox_community.png`);
        setQrcodeUrl(`${window.location.origin}/qrcode_smallbox_community.png`);
        break;
      default:
        setModelTitle('- x86尊享交流群 -');
        setModelQrcode('https://h5-box.onethingpcs.com/recruit.png');
        setQrcodeUrl(`${window.location.origin}/recruit.png`);
        break;
    }
  }, [fromIndex]);

  useMounted(() => {
    fixedBody();
    setTimeout(() => setInProp(true), 200);
  });

  useUnmount(() => {
    looseBody();
  });
  return (
    <div className={styles.modal} onClick={handleClose}>
      <CSSTransition in={inProp} timeout={200} classNames="fade" mountOnEnter unmountOnExit>
        <div className={styles.modalContent} onClick={e => e.stopPropagation()}>
          <h3 className={styles.title}>{modelTitle}</h3>
          <div className={styles.qrCode}>
            <img src={qrcodeUrl} alt="社群二维码" />
          </div>
          <p className={styles.serviceText}>
            微信扫码加群
            <br />
            技术大牛给你指引
          </p>
          <button onClick={handleSaveQRCode}>保存到相册</button>
        </div>
      </CSSTransition>
    </div>
  );
};
export default CommunityModal;
